import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
} from "reactstrap";

const Step5 = () => {
  const [employeeCount, setEmployeeCount] = useState("");
  const [fullTimeBasis, setFullTimeBasis] = useState("");
  const [contractsUpToDate, setContractsUpToDate] = useState("");
  const [fullTimeEquivalent, setFullTimeEquivalent] = useState("");
  const [managementTeam, setManagementTeam] = useState("");
  const [decisionMaking, setDecisionMaking] = useState("");
  const [managementRoles, setManagementRoles] = useState("");
  const [businessOperational, setBusinessOperational] = useState("");
  const [performanceReview, setPerformanceReview] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({
      employeeCount,
      fullTimeBasis,
      contractsUpToDate,
      fullTimeEquivalent,
      managementTeam,
      decisionMaking,
      managementRoles,
      businessOperational,
      performanceReview,
    });
  };

  const renderTileOptions = (options, state, setState) => (
    <div className="d-flex gap-3 flex-wrap">
      {options.map((option, index) => (
        <div
          key={index}
          style={{ width: "220px", height: "200px" }}
          className={`box flex items-center justify-center p-4 rounded-lg cursor-pointer ${
            state === option ? "selected bg-[#A3E566] text-blue" : "bg-gray-100 text-black"
          }`}
          onClick={() => setState(option)}
        >
          {option}
        </div>
      ))}
    </div>
  );

  return (
    <Container>
      <Row className="justify-content-center">
        <Col md={8} lg={8} xl={8}>
          <Card className="overflow-hidden">
            <div className="bg-primary text-center p-4">
              <h5 className="text-white font-size-20"  style={{ fontSize: "1.2rem" }}>About your business</h5>
              <p className="text-white-50"  style={{ fontSize: "1.2rem",marginTop: "1rem", marginBottom: "1rem"  }}>
                We want to get to know the people in your business.
              </p>
            </div>
            <CardBody className="p-4">
              <form onSubmit={handleSubmit}>
                <label style={{ fontSize: "1.2rem",  marginTop: "2rem", marginBottom: "2rem" }}>How many employees work in your business?</label>
                {renderTileOptions(["Just me", "1 - 4", "5 - 19", "20 - 49", "50+"], employeeCount, setEmployeeCount)}

                <label style={{ fontSize: "1.2rem", marginTop: "2rem", marginBottom: "2rem" }}>And are all these employees hired on a full-time basis?</label>
                {renderTileOptions(["Yes", "No"], fullTimeBasis, setFullTimeBasis)}

                {fullTimeBasis === "Yes" && (
                  <>
                    <label style={{ fontSize: "1.2rem", marginTop: "2rem", marginBottom: "2rem" }}>Are all employment contracts for your staff up to date?</label>
                    {renderTileOptions(["Yes", "No"], contractsUpToDate, setContractsUpToDate)}
                  </>
                )}

                {fullTimeBasis === "No" && (
                  <>
                    <label style={{ fontSize: "1.2rem", marginTop: "2rem", marginBottom: "2rem" }}>How many Full Time Equivalent Staff do you have?</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter number"
                      value={fullTimeEquivalent}
                      onChange={(e) => setFullTimeEquivalent(e.target.value)}
                    />
                  </>
                )}

                <label style={{ fontSize: "1.2rem", marginTop: "2rem", marginBottom: "2rem" }}>How would you describe the senior management team?</label>
                {renderTileOptions(
                  [
                    "There isn’t a dedicated management team.",
                    "One or more employees manage these responsibilities.",
                    "It’s handled by the owner(s) of the business.",
                  ],
                  managementTeam,
                  setManagementTeam
                )}

                {managementTeam === "There isn’t a dedicated management team." && (
                  <>
                    <label style={{ fontSize: "1.2rem" , marginTop: "2rem", marginBottom: "2rem"}}>Who is currently responsible for decision-making and daily operations?</label>
                    {renderTileOptions(["Shared among employees", "No clear structure in place"], decisionMaking, setDecisionMaking)}
                  </>
                )}

                {managementTeam === "One or more employees manage these responsibilities." && (
                  <>
                    <label style={{ fontSize: "1.2rem", marginTop: "2rem", marginBottom: "2rem" }}>Does the business have clear management roles in place?</label>
                    {renderTileOptions(["Yes, we have a structured leadership team", "No, roles and responsibilities aren’t clearly defined"], managementRoles, setManagementRoles)}
                  </>
                )}

                {managementTeam === "It’s handled by the owner(s) of the business." && (
                  <>
                    <label style={{ fontSize: "1.2rem", marginTop: "2rem", marginBottom: "2rem" }}>If the owner(s) could no longer work in the business, would the business still be able to operate?</label>
                    {renderTileOptions(
                      [
                        "Not at all - the business would stop immediately.",
                        "A few months - the business could operate short-term but struggle.",
                        "Around a year - the business could continue for a while with some adjustments.",
                        "Longer than a year - the business is structured to run independently.",
                      ],
                      businessOperational,
                      setBusinessOperational
                    )}
                  </>
                )}

                <label style={{ fontSize: "1.2rem", marginTop: "2rem", marginBottom: "2rem" }}>How often does the business conduct performance reviews for staff?</label>
                {renderTileOptions(["Quarterly", "Every 6 months", "Once a year", "We don't currently do this."], performanceReview, setPerformanceReview)}

                {/* <div className="text-end mt-3">
                  <Button color="primary" type="submit">
                    Submit
                  </Button>
                </div> */}
              </form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Step5;
